import React, { useState } from 'react'
import { string, object, bool, any } from 'prop-types'

const Collapse = ({
  children,
  header,
  showToggleIcon = false,
  customToggleIcon = false,
  className = '',
  style = {}
}) => {
  const [hide, setHide] = useState(true)
  const toggleIcon = customToggleIcon || <div className="plus-minus" />
  return (
    <div {...{ className, style }}>
      <div className={'item ' + (!hide ? 'open' : '')}>
        <div
          className="header visible-part"
          onClick={() => {
            setHide(!hide)
          }}
        >
          {header}
          {showToggleIcon && toggleIcon}
        </div>
        <div className="hidden-part">
          <div className="hidden-details">{children}</div>
        </div>
      </div>
    </div>
  )
}

Collapse.propTypes = {
  children: any,
  className: string,
  customToggleIcon: bool,
  header: any,
  showToggleIcon: bool,
  style: object
}

Collapse.displayName = 'Collapse'

export default Collapse
